import React from "react";
import { ToggleSwitchContainer } from "./ToggleSwitch.styles";

interface ToggleSwitchProps {
  options: string[];
  activeOption: string;
  onToggle: (option: string) => void;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ options, activeOption, onToggle }) => (
  <ToggleSwitchContainer
    value={activeOption}
    options={options.map((option) => ({ label: option, value: option }))}
    onChange={onToggle}
  />
);

export default ToggleSwitch;
